import React, { ReactElement, useState } from "react";
import { FiTrash } from "react-icons/fi";
import { HiPencilAlt } from "react-icons/hi";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import PrimaryButton from "../Button/PrimaryButton";
import SecondaryButton from "../Button/SecondaryButton";
import styles from "./ConfirmButtons.module.scss";

type Props = {
  confirmHandler?: () => void;
  confirmText?: ReactElement;
  link?: string;

  showEdit?: boolean;
  showDelete?: boolean;
};

const ConfirmButtons: React.FC<Props> = ({
  confirmHandler,
  confirmText,
  link,
  showEdit = true,
  showDelete = true,
}) => {
  const [confirm, setConfirm] = useState(false);

  return (
    <>
      {/* EDIT BUTTON */}
      {showEdit && !confirm && link && (
        <Link to={link} className={styles.item}>
          <PrimaryButton size="small">
            <HiPencilAlt size={18} />
          </PrimaryButton>
        </Link>
      )}

      {/* DELETE BUTTON */}
      {showDelete && (
        <span className={styles.item}>
          {confirm ? (
            <>
              {confirmText && <p>{confirmText}</p>}

              <SecondaryButton
                size="small"
                onClick={() => confirmHandler?.()}
              >
                <FormattedMessage id="site.yes" defaultMessage="yes" />
              </SecondaryButton>

              <SecondaryButton
                size="small"
                onClick={() => setConfirm(false)}
              >
                <FormattedMessage id="site.no" defaultMessage="no" />
              </SecondaryButton>
            </>
          ) : (
            <SecondaryButton
              size="small"
              onClick={() => setConfirm(true)}
            >
              <FiTrash size={18} />
            </SecondaryButton>
          )}
        </span>
      )}
    </>
  );
};

export default ConfirmButtons;